import { FC } from 'react';

import DividendsSectionHeader from './DividendsSectionHeader';
import DividendsSectionBody from './DividendsSectionBody';

const DividendsSection: FC = () => (
  <>
    <DividendsSectionHeader />
    <DividendsSectionBody />
  </>
);

export default DividendsSection;
